<ion-button
  fill="outline"
  color="primary"
  expand="block"
  libClickStopPropagation
  (click)="showIncidenceModal()"
>
  <ion-icon
    slot="start"
    aria-hidden="true"
    src="../assets/material-symbols/warning_24dp_FILL0_wght400_GRAD0_opsz24.svg"
  ></ion-icon>
  {{ 'freight.general.incident' | translate }}
</ion-button>
